'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _EduCenterFinRisks = require('./EduCenterFinRisks.css');

var _EduCenterFinRisks2 = _interopRequireDefault(_EduCenterFinRisks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkList = (_dec = (0, _reactCssModules2.default)(_EduCenterFinRisks2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(LinkList, _Component);

  function LinkList() {
    (0, _classCallCheck3.default)(this, LinkList);
    return (0, _possibleConstructorReturn3.default)(this, (LinkList.__proto__ || (0, _getPrototypeOf2.default)(LinkList)).apply(this, arguments));
  }

  (0, _createClass3.default)(LinkList, [{
    key: 'render',
    value: function render() {
      if (!this.props.list || this.props.list.length <= 0) {
        return null;
      }
      return _react2.default.createElement(
        'ul',
        null,
        this.props.list.map(function (e, i) {
          var _e = (0, _slicedToArray3.default)(e, 3),
              author = _e[0],
              title = _e[1],
              url = _e[2];

          return _react2.default.createElement(
            'li',
            { key: 'link-list-' + i },
            _react2.default.createElement(
              _components.Link,
              {
                to: url,
                title: title,
                xstrong: true
              },
              author
            ),
            '\xA0\u2014\xA0',
            title
          );
        })
      );
    }
  }]);
  return LinkList;
}(_react.Component)) || _class);
var EduCenterFinRisks = (_dec2 = (0, _reactCssModules2.default)(_EduCenterFinRisks2.default, { allowMultiple: true }), _dec2(_class2 = function (_Component2) {
  (0, _inherits3.default)(EduCenterFinRisks, _Component2);

  function EduCenterFinRisks(props) {
    (0, _classCallCheck3.default)(this, EduCenterFinRisks);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (EduCenterFinRisks.__proto__ || (0, _getPrototypeOf2.default)(EduCenterFinRisks)).call(this, props));

    _this2.state = {
      title: 'Financial risks of unsustainable investments',
      description: 'The financial risks of investing unsustainably, like stranded assets, reputational risk, and other negative impacts of unsustainable business practices can destroy shareholder value.',
      url: _config2.default.domain + _config2.default.routes.eduCenterFinRisks
    };
    return _this2;
  }

  (0, _createClass3.default)(EduCenterFinRisks, [{
    key: 'render',
    value: function render() {
      // [0,      1,     2]
      // [Author, Title, Url]
      var resourceLinks = [['IEEFA', 'The Financial Case for Fossil Fuel Divestment', 'http://ieefa.org/wp-content/uploads/2018/07/Divestment-from-Fossil-Fuels_The-Financial-Case_July-2018.pdf'], ['Organization and Environment: The Journal of Business Sustainability', 'Fossil Fuel Divestment Strategies: Financial and Carbon-Related Consequences ', 'https://journals.sagepub.com/doi/full/10.1177/1086026618773985'], ['Forbes', 'The Case For Fossil Fuel Divestment', 'https://www.forbes.com/sites/davidcarlin/2021/02/20/the-case-for-fossil-fuel-divestment/'], ['US-SIF', 'Financial Performance with Sustainable Investing', 'https://www.ussif.org/performance'], ['NYU Stern Center for Sustainable Business', 'ESG and Financial Performance: Uncovering the Relationship by Aggregating Evidence from 1,000 Plus Studies Published between 2015 – 2020', 'https://www.stern.nyu.edu/sites/default/files/assets/documents/NYU-RAM_ESG-Paper_2021%20Rev_0.pdf'], ['RBC Global Asset Management', 'Does socially responsible investing hurt investment returns?', 'https://www.rbcgam.com/documents/en/articles/does-socially-responsible-investing-hurt-investment-returns.pdf'], ['Morgan Stanley', 'Sustainable Reality: Analyzing Risk and Returns of Sustainable Funds', 'https://www.morganstanley.com/content/dam/msdotcom/ideas/sustainable-investing-offers-financial-performance-lowered-risk/Sustainable_Reality_Analyzing_Risk_and_Returns_of_Sustainable_Funds.pdf'], ['McKinsey', 'From ‘why’ to ‘why not’: Sustainable investing as the new normal', 'https://www.mckinsey.com/~/media/McKinsey/Industries/Private%20Equity%20and%20Principal%20Investors/Our%20Insights/From%20why%20to%20why%20not%20Sustainable%20investing%20as%20the%20new%20normal/From-why-to-why-not-Sustainable-investing-as-the-new-normal.ashx'], ['Morningstar', 'Sustainable Funds U.S. Landscape Report', 'https://www.morningstar.com/lp/sustainable-funds-landscape-report'], ['University of Oxford and Arabesque Partners', 'From the Stockholder to the Stakeholder: How Sustainability Can Drive Financial Outperformance', 'https://arabesque.com/research/From_the_stockholder_to_the_stakeholder_web.pdf'], ['Morningstar', 'ESG Risk Comes Into Focus', 'https://www.morningstar.com/features/esg-risk']];

      var img1 = require('../../../static/images/fin-risk-oil-chart.jpg');
      var img2 = require('../../../static/images/fin-risk-green-esg.jpg');
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h1',
            { styleName: 'small-page-title' },
            this.state.title
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'copy' },
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'The financial risks of investing unsustainably, like stranded assets, reputational risk, and other negative impacts of unsustainable business practices can destroy shareholder value. There is a widespread myth that investing sustainably means sacrificing returns. But if anything, the evidence suggests the opposite is true.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'If you believe you must sacrifice returns in order to invest sustainably, you are not alone. In fact, ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.morganstanley.com/content/dam/msdotcom/ideas/sustainable-investing-offers-financial-performance-lowered-risk/Sustainable_Reality_Analyzing_Risk_and_Returns_of_Sustainable_Funds.pdf', title: 'Morgan Stanley \u2014 Sustainable Reality: Analyzing Risk and Returns of Sustainable Funds', xstrong: true },
                '53% of investors assume'
              ),
              ' that sustainable investing requires a financial trade-off. But contrary to popular belief, adding unsustainable investments to your portfolio could actually be increasing your financial risk.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Research conducted on the performance of nearly 11,000 mutual funds between 2004 and 2018 found that not only did sustainable funds provide returns in line with their traditional counterparts over the short and long-term, but ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.morganstanley.com/content/dam/msdotcom/ideas/sustainable-investing-offers-financial-performance-lowered-risk/Sustainable_Reality_Analyzing_Risk_and_Returns_of_Sustainable_Funds.pdf', title: 'Morgan Stanley \u2014 Sustainable Reality: Analyzing Risk and Returns of Sustainable Funds', xstrong: true },
                'they were also 20% less risky.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'img-blockquote' },
              _react2.default.createElement(
                'blockquote',
                null,
                'As we transition towards a low-carbon economy, the economic viability of energy companies\u2019 heavy investments in the extraction and production of oil and gas will be under pressure.'
              ),
              _react2.default.createElement('img', {
                src: img1,
                alt: 'As we transition towards a low-carbon economy, the economic viability of energy companies\u2019 heavy investments in the extraction and production of oil and gas will be under pressure.'
              })
            ),
            _react2.default.createElement(
              'p',
              null,
              'Recently, this risk has been clearly demonstrated by the energy sector, which once led the world economy and stock markets, but has now become the smallest sector in the S&P 500. Investors who have chosen to avoid this risky sector have seen their returns prosper. Since its inception in 2012, the ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.forbes.com/sites/davidcarlin/2021/02/20/the-case-for-fossil-fuel-divestment/?sh=4b7414276d22', title: 'Forbes \u2014 The Case For Fossil Fuel Divestment', xstrong: true },
                'S&P 500\u2019s Fossil Fuel Free Total Return Index has consistently outperformed the S&P 500 overall.'
              ),
              ' When you examine individual companies, their performance can be seen as a microcosm of the energy sector\u2019s sharp decline. For instance, ExxonMobil, which was the world\u2019s most valuable company in 2011, was removed from the Dow in 2020.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Over the years, investors have seen how ESG related risk can negatively impact a company\u2019s stock price as well as its reputation. By ignoring ESG issues, companies are financially liable to pay hefty regulatory fines and settlements while simultaneously tarnishing their brand. For instance, in 2010 during the Deepwater Horizon oil spill, British Petroleum\u2019s stock price plummeted 50% over the course of two months. ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://arabesque.com/research/From_the_stockholder_to_the_stakeholder_web.pdf', title: 'University of Oxford and Arabesque Partners \u2014 From the Stockholder to the Stakeholder: How Sustainability Can Drive Financial Outperformance', xstrong: true },
                'Some reports estimate'
              ),
              ' that the company\u2019s cleanup cost for this disaster alone were upwards of $90 billion. To this day, BP has still not recovered in value and has been unable to shake its soiled reputation.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'While some investors still question the short-term performance of sustainable investments, numerous studies have shown that these types of investments are more risk adverse in the short term, particularly during social and economic crises. In 2020, financial markets experienced unprecedented losses due to the outbreak of the coronavirus pandemic. Employees across the U.S. saw their 401(k) account balances ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.cnbc.com/2020/04/24/401k-balances-sink-19-percent-due-to-coronavirus-fidelity-says.html', title: 'CNBC: 401(k) balances sink 19% due to coronavirus, Fidelity says', xstrong: true },
                'drop by an average of 19%'
              ),
              ' in the first quarter of 2020 alone. These dramatic losses stemmed in large part from investing in funds which included oil and gas companies. And due to the intricacies of retirement plans, most employees are currently unaware that they are likely invested in these risky and volatile industries.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'img-blockquote' },
              _react2.default.createElement(
                'blockquote',
                null,
                'Not only are sustainable investments less risky in the short-term, simply put, companies that have strong ESG values are inherently more fit to thrive in the long run.'
              ),
              _react2.default.createElement('img', {
                src: img2,
                alt: 'Not only are sustainable investments less risky in the short-term, simply put, companies that have strong ESG values are inherently more fit to thrive in the long run.'
              })
            ),
            _react2.default.createElement(
              'p',
              null,
              'On the other hand, in 2020, U.S. sustainable equity funds\u2019 median downside deviation, which measures the risk and price volatility of investments, was 3.1 percentage points less than traditional peer funds. Additionally, investors of U.S. sustainable equity funds ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.morganstanley.com/ideas/esg-funds-outperform-peers-coronavirus', title: 'Morgan Stanley - Sustainable Funds Outperform Peers in 2020 During Coronavirus', xstrong: true },
                'earned an average return of 4.3 more points'
              ),
              ' over those who chose to invest in traditional funds. Overall, during a year highlighted by market volatility, sustainable stocks and bonds weathered the storm better than their traditional counterparts.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Not only are sustainable investments less risky in the short-term, simply put, companies that have strong ESG values are inherently more fit to thrive in the long run. By addressing issues of climate change and social inequities head on, these companies are proactively taking the necessary steps to adapt their businesses to a constantly changing world. The message to companies: if you don\u2019t adapt, you will be left behind.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Companies that do not plan for the future are also at risk of increasing their exposure to investments in stranded assets. A stranded asset is a resource or equipment that turns out to be worth less than expected as a result of external changes. As we transition towards a low-carbon economy, the ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://carbontracker.org/reports/', title: 'Carbon Tracker - Reports', xstrong: true },
                'economic viability of energy companies\u2019 heavy investments in the extraction and production of oil and gas'
              ),
              ' will be under pressure. As a result, investors in these industries may see their returns dwindle, and many already have started to see this firsthand.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Businesses need to adopt to a changing world for the long-term viability of their operations, but also for the investors they seek to satisfy. Demand for ESG investments ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.pionline.com/esg/global-esg-data-driven-assets-hit-405-trillion', title: 'Pensions & Investments - Global ESG-data driven assets hit $40.5 trillion', xstrong: true },
                'has doubled over the past four years,'
              ),
              ' and tripled over the past eight. The global value of assets incorporating ESG in some way now represents over a quarter of all investments worldwide, translating into roughly $45 trillion in 2020. In response, ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.blackrock.com/corporate/investor-relations/2020-blackrock-client-letter', title: 'Sustainability as BlackRock\u2019s New Standard for Investing', xstrong: true },
                'institutional investors like BlackRock have pledged'
              ),
              ' to make ESG a central component of their investing strategy as they seek to satisfy this surge in demand.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'As investors across the world continue to enter the ESG market at an exponential rate, they are beginning to realize that sustainable investing is no longer a zero-sum game. It is possible to invest sustainably, avoid financial risk, and support the transition to an economy that is based on justice and sustainability. ',
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.routes.eduCenterIndividual, title: 'Action center', xstrong: true },
                'Visit our Action Center'
              ),
              ' to learn more about how you can work with your employer to ensure your retirement plan is sustainably invested.'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'copy' },
            _react2.default.createElement(
              'h2',
              null,
              'Additional resources'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Risks of fossil fuel investments'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'resource-links' },
            _react2.default.createElement(LinkList, { list: resourceLinks.slice(0, 3) })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'copy' },
            _react2.default.createElement(
              'h3',
              null,
              'The myth of ESG underperformance'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'resource-links' },
            _react2.default.createElement(LinkList, { list: resourceLinks.slice(3, resourceLinks.length) })
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.HomeEduCenter, null)
      );
    }
  }]);
  return EduCenterFinRisks;
}(_react.Component)) || _class2);
exports.default = EduCenterFinRisks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/EduCenterFinRisks/EduCenterFinRisks.js
// module id = 1472
// module chunks = 0